import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M11.4 3.2C11.7556 2.93333 12.2444 2.93333 12.6 3.2L20.6 9.2C20.8518 9.38885 21 9.68524 21 10V21C21 21.5523 20.5523 22 20 22H15C14.4477 22 14 21.5523 14 21V15.75C14 15.4739 13.7761 15.25 13.5 15.25L10.5 15.25C10.2239 15.25 10 15.4739 10 15.75V21C10 21.5523 9.55228 22 9 22H4C3.44772 22 3 21.5523 3 21V10C3 9.68524 3.14819 9.38885 3.4 9.2L11.4 3.2Z" />,
  'Home',
)
